<template>
  <div class="flex grid lg:grid-cols-12 w-full gap-6">
    <!-- Main Coach Section Skeleton -->
    <div class="col-span-12 sm:col-span-9 flex flex-col gap-4">
      <div class="flex items-center gap-2">
        <h1 class="text-text-primary font-semibold text-[24px]">{{ $t('home.coach.title') }}</h1>
        <div
          class="text-[10px] rounded-md px-1 py-[1px] mr-1 self-start"
          style="
            background-color: rgba(208, 113, 197, 0.125);
            color: rgb(208, 113, 197);
          "
        >
          {{ $t('home.coach.beta') }}
        </div>
        <div class="has-tooltip">
          <img
            src="../../assets/icons/info-icon.svg"
            :alt="$t('home.coach.info_icon_alt')"
            class="w-6 h-6 cursor-pointer"
          />
          <div class="tooltip bg-gray-900 rounded-lg p-2 ml-8 -mt-7">
            <p class="text-text-secondary text-xs">
              {{ $t('home.coach.rank_comparison_tooltip') }}
            </p>
          </div>
        </div>
      </div>

      <div class="bg-gray-900 rounded-lg flex flex-col flex-grow">
        <!-- Loading skeleton for stats tabs -->
        <nav class="w-full grid grid-cols-3 items-center justify-center relative">
          <div
            v-for="index in 3"
            :key="index"
            class="py-3 flex flex-col gap-2 col-span-1 items-center justify-center border-b border-gray-800"
          >
            <div class="h-4 w-20 rounded animate-pulse" />
          </div>
        </nav>

        <div class="flex p-4 gap-4 sm:gap-16 flex-grow flex-col sm:flex-row">
          <!-- Left Content Skeleton -->
          <div class="flex-1 flex flex-col gap-3">
            <!-- Loading skeleton for title -->
            <div class="h-7 w-48 bg-gray-800 rounded animate-pulse" />

            <!-- Loading skeleton for description -->
            <div class="flex flex-col gap-2">
              <div class="h-4 w-full bg-gray-800 rounded animate-pulse" />
              <div class="h-4 w-3/4 bg-gray-800 rounded animate-pulse" />
            </div>

            <div class="w-full h-px bg-gray-800 xl:w-4/5" />

            <!-- Loading skeleton for second description -->
            <div class="flex flex-col gap-2">
              <div class="h-4 w-full bg-gray-800 rounded animate-pulse" />
              <div class="h-4 w-2/3 bg-gray-800 rounded animate-pulse" />
            </div>

            <!-- Loading skeleton for button -->
            <div class="mt-auto py-3 w-full rounded-lg bg-gray-800 animate-pulse h-12" />
          </div>

          <!-- Right Chart Skeleton -->
          <div class="flex-1 flex items-stretch p-2">
            <div class="flex-1 bg-gray-800 rounded-lg border-gray-700 border p-5 flex flex-col">
              <div class="flex-1 flex gap-8">
                <div class="flex flex-col gap-1">
                  <div class="flex gap-1 items-center">
                    <div class="h-2 w-2 rounded-sm" />
                    <div class="h-3 w-16 rounded animate-pulse" />
                  </div>
                  <div class="h-6 w-12 rounded animate-pulse" />
                </div>
                <div class="flex flex-col gap-1">
                  <div class="flex gap-1 items-center">
                    <div class="h-2 w-2 rounded-sm" />
                    <div class="h-3 w-20 rounded animate-pulse" />
                  </div>
                  <div class="h-6 w-12 rounded animate-pulse" />
                </div>
              </div>
              <!-- Loading skeleton for chart -->
              <div class="h-[120px] flex items-center justify-center">
                <div class="w-full h-full rounded animate-pulse" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Coach Routine Section Skeleton -->
    <div class="flex flex-col gap-4 col-span-12 sm:col-span-3 sm:justify-start">
      <h1 class="h-[36px] text-text-primary font-semibold text-[24px]">{{ $t('home.coach.routines_title') }}</h1>
      <div class="flex-1 bg-gray-900 rounded-lg p-4 flex flex-col gap-2">
        <div
          class="w-16 h-16 bg-gray-800 border border-gray-700 rounded-full flex items-center justify-center mb-2"
        >
          <div class="w-8 h-8 rounded animate-pulse" />
        </div>

        <div class="h-5 w-3/4 bg-gray-800 rounded animate-pulse" />

        <div class="flex flex-col gap-2 flex-1">
          <div class="h-3 w-full bg-gray-800 rounded animate-pulse" />
          <div class="h-3 w-5/6 bg-gray-800 rounded animate-pulse" />
          <div class="h-3 w-2/3 bg-gray-800 rounded animate-pulse" />
        </div>

        <div class="mt-6 py-3 w-full rounded-lg bg-gray-800 animate-pulse h-12" />
      </div>
    </div>
  </div>
</template>

<script setup>
// No props or logic needed - this is a pure skeleton component
</script>
